<template>
  <div class="login">
    <div class="login_box">
      <div class="left">
        <div class="left_box">
          <div>
            <img class="left_logo" src="../../assets/img/Logo.png" alt="">
          </div>
          <div>
            <img class="left_img" src="../../assets/img/img_signup.png" alt="">
          </div>
        </div>
      </div>
      <div class="right">
        <div class="top_right_box1">
            <!-- 语言切换 -->
            <el-popover
                placement="bottom"
                popper-class="top_user lan_popover"
                width="70"
                v-model="visible_lan"
                trigger="click">
                <span slot="reference">
                  <span class="lan_icon" v-if="v_lan=='ch' ">简体中文</span>
                  <span class="lan_icon" v-else-if="v_lan=='jp' ">日本語</span>
                  <span class="lan_icon" v-else>English</span>
                  <i v-if="visible_lan" class="el-icon-caret-top u_r_icon2"></i>
                  <i v-else class="el-icon-caret-bottom u_r_icon2"></i>
                </span>
                <div class="u_box">
                  <div class="lan_list_item" @click="lang_fun('ch')">简体中文</div>
                  <div class="lan_list_item" @click="lang_fun('en')">English</div>
                  <div class="lan_list_item" @click="lang_fun('jp')">日本語</div>
                </div>  
            </el-popover>
          </div>

        <div class="tit_top" :class="v_lan=='jp'?'tit_top_jp':'' ">
          <span class="tit_top_span">{{$t('main.text30')}}</span>
          <span class="reg_btn" @click="$router.push('/reg')">{{$t('main.text31')}}</span>
        </div>

        <el-form class="form_box" label-position="top" label-width="130px">
          <el-alert
            v-if="api_ok"
            :title="$t('main.text32')"
            type="success"
            show-icon
            class="succ_alert"
            :closable="false"
          >
          </el-alert>
          
          <el-form-item>
            <div class="reg_tit1">{{$t('main.text33')}}</div>
            <div class="reg_tit2">{{$t('main.text34')}}</div>
          </el-form-item>

          <el-form-item :label="$t('main.text250')">
            <el-input v-model.trim="email"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button class="login_btn" @click="email_btn">{{$t('main.text36')}}</el-button>
          </el-form-item>

          <el-form-item>
            <div class="tit_top forget_pwd_footer" :class="v_lan=='jp'?'tit_top_jp':'' ">
              <span class="tit_top_span">{{$t('main.text37')}}</span>
              <span class="reg_btn" @click="$router.push('/login')">{{$t('main.text38')}}</span>
            </div>
          </el-form-item>

        </el-form>

      </div>
    </div>
  </div>
</template>

<script>
import {sendEmail} from '@/api/api';
export default {
  data() {
    return {
      email:'',
      api_ok:false,
      visible_lan:false,
    }
  },
  methods:{
    email_btn(){
      if(this.email==''){
        this.message.ismessage('error',this.$t('main.text39'));
        return false;
      }
      sendEmail({
        email:this.email,
        type:'forgetLoginPassword'
      }).then(res=>{
        if (res.data.code==207) {
          this.message.ismessage('success',res.data.msg);
          this.api_ok=true;
        }else{
          this.message.ismessage('error',res.data.msg);
        }
      })
    },
    lang_fun(v) {
      localStorage.setItem("language", v);
      setTimeout(() => {
        location.reload();
      }, 100);
    },

  }
}
</script>

<style scoped>
.login{
  position: relative;
  width: 100%;
  height: 100vh;
}
.login_box{
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
}
.login_box > div{
  width: 50%;
  height: 100%;
}
.left{
  background:url(../../assets/img/bg_login.png) no-repeat;
  background-size: cover;
  color: #fff;
  position: relative;
}
.left_box{
  width: 100%;
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
.left_logo{
  width: 30%;
  margin-bottom: 20px;
}
.left_img{
  width: 90%;
}
.left_footer{
  margin-top: 20px;
  max-width: 70%;
  margin: auto;
  box-sizing: border-box;
  padding-top: 20px;
}
.left_footer1{
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  margin-bottom: 8px;
}
.left_footer2{
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
}

.right{
  position: relative;
  width: 100%;
}
.tit_top{
  text-align: right;
  color: #314869;
  margin-top: 20px;
  margin-right: 100px;
}
.tit_top_span{
  opacity: 0.6;
}
.reg_btn{
  border: 1.5px solid rgba(49, 72, 105, 0.2);
  box-sizing: border-box;
  border-radius: 4px;
  padding: 8px 20px;
  cursor: pointer;
  margin-left: 10px;
}
.form_box{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  width: 65%;
}
.form_tit{
  color: #314869;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
}
.for_pwd{
  text-align: right;
  color: #DEB981;
  font-size: 15px;
  cursor: pointer;
}
.code_w{
  display: flex;
}
.code_w2{
  width: 68%;
}
.code_w3{
  margin-right: 16px;
  /* border: 1.5px solid rgba(49, 72, 105, 0.1);
  border-radius: 4px; */
  flex: 1;
  /* color: #fff; */
}
.code_w3 span{
  background: #000;
}
.login_btn,
.login_btn:hover{
  width: 100%;
  height: 48px;
  background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-color: #F1C788;
  border-radius: 4px;
  color: #fff;
  margin-top: 25px;
}
.succ_alert{
  background: rgba(48, 211, 167, 0.16);
  color: #266856;
  margin-bottom: 28px;
}
.succ_alert >>> .el-alert__title{
  font-size: 15px;
}

/* ---------------- */
.reg_tit1{
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #314869;
}
.reg_tit2{
  color: rgba(49, 72, 105, 0.6);
}
.form_tit2{
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: rgba(49, 72, 105, 0.6);
}
.el-form-item {
  margin-bottom: 5px;
}
.el-form--label-top .el-form-item__label {
  padding: 0;
}
.reg_code_box{
  position: relative;
  width: 68%;
}
.code_w2{
  width: 100%;
}
.reg_code_btn{
  position: absolute;
  right: 5px;
  top: 5px;
  background: #D6DAE1;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 5px 10px;
  font-size: 15px;
  color: #fff;
  line-height: initial;
  cursor: pointer;
}
/* -------- */
.forget_pwd_footer{
  text-align: center;
  margin-right: 0;
}
.login >>> .el-form--label-top .el-form-item__label{
  color: #5A6D87;
}

/* 语言切换 */
.lan_icon{
  width: 28px;
  height: 28px;
  vertical-align: middle;
  cursor: pointer;
  color: rgb(222, 185, 129);
}
.top_right_box1{
  margin-right: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
}
.u_r_icon2{
  margin-left: 8px;
  cursor: pointer;
  margin-top: 5px;
  color: rgb(222, 185, 129);
}
.lan_list_item{
  cursor: pointer;
  /* width: 28px;
  height: 28px; */
  margin: 10px auto;
  display: block;
}
.head_title2{
  /* max-width: 70%; */
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.top_right_box1 > span{
  /* border: 1px solid rgba(49, 72, 105, 0.2); */
  box-sizing: border-box;
  padding: 2px 6px;
  border-radius: 4px;

}

/* ------ */

</style>

<style>
/* 语言 */
.top_user{
  color: #fff;
  font-size: 15px;
  background: #03101C;
  box-shadow: 0px 4px 8px #03101C;
  border-radius: 16px;
  border: none;
}
.top_user[x-placement^=bottom] .popper__arrow,
.top_user[x-placement^=bottom] .popper__arrow::after{
  display: none;
  border-bottom-color: transparent;
}
.top_user .popper__arrow{
  display: none;
}
.lan_popover{
  min-width: 70px;
  /* transform: translateX(-3px); */
}
/* ---- */
</style>

<style scoped>
  /* 手机端 */
@media screen and (max-width: 850px) {
  .login_box > div.left{
    width: 0;
    display: none;
  }
  .login_box > div.right{
    width: 100%;
  }
  .tit_top{
    margin-right: 20px;
  }
  .form_box{
    width: 80%;
  }
  .form_box{
    transform: translate(-50%,-50%);
    margin-bottom: 0;
  }





}
</style>